import React from 'react'

import AdminLayout from '../components/AdminLayout'

import './cctv.css'

const Cctv = () => {
  return (
    <AdminLayout title="CCTV Monitoring" activeNav="cctv" pageTitle="CCTV Monitoring - Namami Gange">
      <div className="cctv-stats">
        <div className="admin-stat-card">
          <h3>Total Camera</h3>
          <div className="admin-stat-value">24</div>
        </div>
        <div className="admin-stat-card">
          <h3>Online</h3>
          <div className="admin-stat-value" style={{ color: '#16a34a' }}>
            20
          </div>
        </div>
        <div className="admin-stat-card">
          <h3>Offline</h3>
          <div className="admin-stat-value" style={{ color: '#dc2626' }}>
            4
          </div>
        </div>
      </div>

      <div className="cctv-mid">
        <div className="admin-panel">
          <h2>Live Camera Feeds</h2>
          <div className="cctv-feed-grid">
            {[1, 2, 3, 4].map((n) => (
              <div key={n} className="cctv-feed">
                <span className="cctv-feed-badge">Main Gate</span>
                <div className="cctv-feed-rec">
                  <span className="cctv-rec-dot" />
                  10:30 AM
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="admin-panel">
          <div className="cctv-alerts-head">
            <h2 style={{ margin: 0 }}>Recent Alerts</h2>
            <button type="button">View all</button>
          </div>
          {[1, 2, 3, 4, 5].map((n) => (
            <div key={n} className="cctv-alert-row">
              <span className="cctv-alert-dot" />
              <div>
                <strong>Main Gate</strong>
                <div style={{ color: '#727983', fontSize: 12 }}>10:30 AM</div>
                <div>Motion Detected</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="cctv-bottom">
        <div className="admin-panel">
          <h2>All Cameras</h2>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Camera Name</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Last Activity</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {['Main Gate', 'Reactor North', 'Clarifier', 'Outlet'].map((name) => (
                  <tr key={name}>
                    <td>{name}</td>
                    <td>{name === 'Main Gate' ? 'Entrance' : 'Site'}</td>
                    <td>
                      <span className="admin-pill">Online</span>
                    </td>
                    <td>Live</td>
                    <td>
                      <button type="button" className="cctv-eye-btn" aria-label="View">
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="admin-panel">
          <h2>Quick Actions</h2>
          <div className="cctv-quick">
            <button type="button" className="cctv-quick-a">
              Camera Directory
            </button>
            <button type="button" className="cctv-quick-b">
              Playback
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}

export default Cctv
